import React, { useState } from 'react';

interface Props {
  label: string;
  onChange?: (value: boolean) => void;
  active?: boolean;
}

export const SlideToggle: React.FC<Props> = ({ label, onChange, active = false }) => {
  const [toggle, setToggle] = useState(active);

  const handleChange = () => {
    onChange && onChange(!toggle);
    setToggle(!toggle);
  };

  return (
    <div className="w-full">
      <label className="flex w-full cursor-pointer text-sm">
        <input onChange={handleChange} className="hidden" type="checkbox" aria-label="Toggle Button" checked={toggle} />
        <div
          aria-label="Toggle Button"
          className={`relative flex items-center cursor-pointer rounded-full w-8 h-5 grow-0 shrink-0
              ${toggle ? 'bg-navy-blue' : 'bg-sonic-silver'}`}
        >
          <span
            className={`h-3.5 w-3.5 rounded-full bg-white transition-[margin]
              ${toggle ? 'ml-3.5' : 'ml-1'}`}
          />
        </div>
        <span className="text-nero font-semibold text-sm ml-2.5">{label}</span>
      </label>
    </div>
  );
};
